import { createContext, useContext, type ReactNode } from 'react'

/**
 * WHERE THE PERSON IS STANDING, for help (#2502 §5.6, crew contracts c.84012).
 *
 * A page declares `helpPage` (its slug — the key help placements are keyed
 * by) and `helpContext` (the crumb text — "Elevate › Overview" — that the
 * Help lens head says "For …" about and that a support request carries so the
 * customer does not have to explain where they are).
 *
 * This is a NEW React context and deliberately NOT `declareContext`, which
 * belongs to the capture extension: that one tells a capture what record is
 * on screen; this one tells help which page is. `openHelp` is optional — the
 * host that mounts the Help lens supplies it, so a `HelpButton` anywhere below
 * can open an article without being wired by hand.
 */
export interface HelpContextValue {
  /** The page slug help placements are keyed by ("home", "elevate", "trust"). */
  helpPage: string
  /** The crumb text: "Home", "Elevate › Overview". */
  helpContext: string
  /** Opens the Help lens, on an article when one is named. Supplied by the host. */
  openHelp?: (articleId?: string) => void
}

const Ctx = createContext<HelpContextValue | null>(null)

export function HelpContextProvider({ value, children }: { value: HelpContextValue; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

/** The nearest page's help context, or null outside any provider. */
export function useHelpContext(): HelpContextValue | null {
  return useContext(Ctx)
}
